/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {BookOfShadowsReelController} from "../../reel/BookOfShadowsReelController";
import {BookOfShadows} from "../../BookOfShadows";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BookOfShadowsParsedGameData} from "../../server/data/BookOfShadowsParsedGameData";

export class ReelStop implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private readonly _reelId: number;
    private readonly _stopDelay: number;
    private readonly _quickStopDelay: number;

    /**
     * @constructs
     * @param reelId
     * @param stagger
     * @param abortStagger
     */
    constructor(reelId: number, stagger?: number, abortStagger?: number) {
        this._reelId = reelId;
        this._stopDelay = BookOfShadows.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = BookOfShadows.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if (stagger !== undefined) {
            this._stopDelay = stagger;
        }
        if (abortStagger !== undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: BookOfShadowsParsedGameData): void {
        // this._nearWinReels = data.nearWinReels;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedGameData): Timeline | null {
        this.stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;

        return this.stopReel(data, false);
    }

    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: ParsedGameData): Timeline | null {
        return this.stopReel(data, true);
    }

    /**
     * @description To stop the reel.
     * @param data
     * @param isQuickStop
     */
    private stopReel(data: ParsedGameData, isQuickStop: boolean): Timeline | null {
        (Reels.getReel(this._reelId) as BookOfShadowsReelController)!.updateGameData(data);

        return BookOfShadows.timelineReelsController.stopSpin(this._reelId, data, isQuickStop);
    }
}